"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envDeleteFirst = void 0;
function envDeleteFirst(env, name) {
    switch (env["@kind"]) {
        case "EnvNull": {
            return env;
        }
        case "EnvCons": {
            if (env.name === name) {
                return env.rest;
            }
            else {
                return envDeleteFirst(env.rest, name);
            }
        }
    }
}
exports.envDeleteFirst = envDeleteFirst;
//# sourceMappingURL=envDeleteFirst.js.map